export const PRODUCT_TYPE_PROPERTY_NODE_TYPE = 'PRODUCTTYPEPROPERTY'

export const BP_STYLING = {
    ICON_MARGIN_LEFT: '4px',
    ICON_FONT_SIZE_PX: 22,
    ICON_MIN_WIDTH_SPACING: 4,
    ICON_PADDING_TOP_SPACING: 0.25,
    ICON_Z_INDEX: 1001,
    ICON_COLOR: '#0A8050',
} as const

export const BP_ERROR_MESSAGES = {
    ADD_UPDATE_FAILED:
        'Failed to update Best Practice settings. Please try again.',
    REMOVE_FAILED: 'Failed to remove Best Practice tag. Please try again.',
    FETCH_FAILED:
        'Failed to load Best Practice data. Please refresh and try again.',
    PERMISSION_DENIED:
        'You do not have permission to modify Best Practice settings.',
} as const

export const BP_TEST_IDS = {
    ICON_WRAPPER: 'best-practices-icon-wrapper',
    BP_ICONS: 'bp-icons',
    MORE_MENU: 'moreMenu',
    OPTION_TEXT_PREFIX: 'option-text-',
    SPECIFIER_NOTES: 'specifier-notes',
    SPECIFIER_NOTES_SMM_OM: 'specifier-notes-smm-om',
} as const

/** Synthetic node-key values used to identify non-content tree rows. */
export const BP_NODE_KEYS = {
    PRODUCT_LIBRARY_BUTTON: 'product-library-button',
} as const

/** BP feature mode literals — mirror the BPMode union in bpManagement.types. */
export const BP_MODE = {
    NONE: 'none',
    PARAMETER: 'parameter',
    GLOBAL: 'global',
} as const

/** Parameter input-type literals — mirror the ParameterInputType union in bpManagement.types. */
export const PARAMETER_INPUT_TYPE = {
    SELECT: 'select',
    MULTI_SELECT: 'multiSelect',
    TEXT_FIELD: 'textField',
} as const

/** Parameter keys mapped to dedicated mutation fields instead of the firm modifier-list flow. */
export const NON_MODIFIER_PARAMETER_KEYS = {
    PROJECT_GROUP: 'projectGroup',
    CITY: 'city',
    PROVINCE_STATE: 'provinceState',
} as const

/** UI text rendered in the BP management panel and remove-confirmation dialog. */
export const BP_PANEL_TEXT = {
    PANEL_TITLE: 'Best Practice Management',
    REMOVE_DIALOG_HEADING: 'Best Practices',
    REMOVE_DIALOG_BODY:
        'Are you sure you want to remove the selected content as a Best Practice?',
    REMOVE_DIALOG_CANCEL: 'Cancel',
    REMOVE_DIALOG_CONFIRM: 'Yes',
} as const
